import React from "react";
import { Language } from "imports/Utils";

export function showFile(file, type) {
	if (!file) {
		return;
	}
	if (type.includes("pdf")) {
		return <iframe src={base64PDFToBlobUrl(file)} style={{ minWidth: "100%", minHeight: 610, display: "flex", flexGrow: 1 }} />;
	}
	if (type.match(/(jpg|jpeg|png|gif)$/i)) {
		return <img src={`data:image/${type};base64,${file}`} style={{ objectFit: "contain", maxWidth: "100%", maxHeight: "100%", width: "100%" }} />;
	}
	return Language("FILE_TYPE_NO_PREVIEW");
}

function base64PDFToBlobUrl(base64) {
	const binStr = atob( base64 );
	const len = binStr.length;
	const arr = new Uint8Array(len);
	for (let i = 0; i < len; i++) {
		arr[ i ] = binStr.charCodeAt( i );
	}
	const blob =  new Blob( [ arr ], { type: 'application/pdf' } );
	const url = URL.createObjectURL( blob );
	return url;
}

export function getFilePropsFromResponse(fileResponse) {
	const type = Object.keys(fileResponse)[0];
	return {
		type: type,
		file: fileResponse[type],
	};
}
